<template lang="pug">
div
  FlowEditor(
    v-if="flowsLoaded",
    :show-not-passed="showNotPassed",
    :flow-aliases="flowAliases",
    :flows="flows",
    :expert="expert",
    :caseID="caseID"
  )
</template>

<script>
import FlowEditor from "./FlowEditor";

export default {
  name: "flow_editor_container",

  components: {
    FlowEditor,
  },

  props: {
    showNotPassed: {
      type: Boolean,
      default: false,
    },

    flows: {
      type: Array,
      default: () => [],
    },

    expert: {
      type: Boolean,
      default: false,
    },

    flowAliases: {
      type: Array,
      default: () => [
        "case_free",
        "case_paid",
        "case_paid_key",
        "case_paid_officer",
        "case_paid_cos",
        "case_paid_lvl1",
      ],
    },

    caseID: {
      type: [String, Number],
    },
  },

  computed: {
    flowsLoaded() {
      return !this.$store.state.flows.isFlowsListLoading;
    },
  },
};
</script>
